// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
if (window.location.hostname === 'winteckorea.synology.me' && window.location.port === '3000') {
  window.location.href = 'https://wp.winteckorea.synology.me';
}
const container = document.getElementById('root');
const root = createRoot(container); // createRoot를 사용하여 루트 설정

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
